import React, { useState, useEffect } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import ButtonPolicy from "src/components/Permission/ButtonPolicy";
import 'chartjs-plugin-datalabels';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";


/**   Component Description
 * 
 * @param {rows} rows has to be fetched from parent component and fed to it to populate level 1 of table
 * @param {coluns} columns that compose the table of level 1
 * @param {innercolumns} innercolumns : columns for table in level 2
 * @param {apicall} apicall : apicall to make for fetching rows of table level 2
 * @returns  Generic a two level datagrid table 
 */
const BudgetDataGridComponent = ({ rows, columns, innerColumns, apicall }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [showMainDataGrid, setShowMainDataGrid] = useState(true); // for controlling first tabe block visibilty
  const [selectedRow, setSelectedRow] = useState(null); //for controlling datepicker visibility
  const [innerRows, setInnerRows] = useState(null);
  const handleConfirmButton = () => {
    setIsOpen(false);

  }
  const handleRowClick = (row) => {
    // Check if the click target has the "chart-button" class (buttons in the last column)
    console.log(row)
    setSelectedRow(row)
    if (selectedRow===row && apicall && !innerColumns)  {  // because if selectedrow is clicked twice in a row, useEffect doesnt trigger
      console.log("entered inside")
       apicall(selectedRow)}
  };


  {/**fetch budgets*/ }
  useEffect(() => {
    if (selectedRow && innerColumns)  {
      console.log("selectedRow : ",selectedRow)
      setShowMainDataGrid(false)
      const fetchData = async () => {
        try {
          var budgets = await apicall(selectedRow.id);
          let id = 0;
          budgets = budgets.map((budget) => {
            return { id: id++, Asset: budget.assetName, Budget: budget.budgetAmount, Spent: budget.spent, Balance: budget.balance + ' %',Tickets:budget.numTicket,TimeSpent:budget.timeSpentToSolve, };
          });

          setInnerRows(budgets);
        } catch (error) {
          // Handle error if needed
          console.error(error);
         // const budgets = [{ id: 0, Asset: "Innerqwerty", Budget: 300, Spent: 1200, Balance: 80 + ' %' }] //dummy static data
          setInnerRows(budgets);
        }
      };

      fetchData();
    }

    if (selectedRow && apicall && !innerColumns)  {
      console.log("entered inside")
       apicall(selectedRow)}
  }, [selectedRow]);




  const handleBackButton = () => {

    setSelectedRow(false);
    setShowMainDataGrid(true)
  };

  // Prepare data for CSV export


  return (
    <div style={{ width: '100%', marginBottom: 15 }}>
      {showMainDataGrid && (
        <div>
          <div className='datePicker'>
            <span onClick={() => setIsOpen(!isOpen)}><CalendarTodayIcon /></span>

            <span> {startDate.toLocaleDateString('en-GB', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
            })} -
              {endDate.toLocaleDateString('en-GB', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
              })}</span>

          </div>
          {isOpen && (
            <div className='dateDropdown'>
              <div className='startDatePicker'><span className='fromTo'>From:</span> <DatePicker selected={startDate} onChange={(date) => setStartDate(date)} dateFormat="dd/MM/yyyy" /></div>
              <div className='endDatePicker'><span className='fromTo'>To:</span> <DatePicker selected={endDate} onChange={(date) => setEndDate(date)} /></div>
              <div className='confirmButton'>
                <ButtonPolicy color="primary" onClick={handleConfirmButton}>
                  Confirm
                </ButtonPolicy>
              </div>
            </div>
          )}
          <DataGrid columns={columns} rows={rows} className='reportDataGrid' onRowClick={(params) => handleRowClick(params.row)} />
        </div>
      )}
     {selectedRow && innerRows && innerRows.length > 0 && (
  <div>
    <span className="backButton" onClick={() => handleBackButton()}>
      <ArrowBackIcon />
    </span>
    <DataGrid columns={innerColumns} rows={innerRows} className='reportDataGrid' />
  </div>
)}

    </div>
  );
};

export default BudgetDataGridComponent;